(function () {
    'use strict';

    angular.module('app').
        controller('CompanyAccessModalController', CompanyAccessModalController);

    CompanyAccessModalController.$inject = [
        '$uibModalInstance',
        'ClientService',
        'companies',
        'OfficesTableService',
        'selectedCompany'

    ]

    function CompanyAccessModalController($uibModalInstance, ClientService, companies, OfficesTableService, selectedCompany) {
        const vm = this;
        vm.save = confirm;
        vm.dismiss = modalDismiss;
        vm.close = close;
        vm.search = search;
        vm.initOffices = initOffices;
        vm.companySelected = [];
        vm.companyList = [];

        vm.officesTable = new OfficesTableService({ selectAll: selectAll });
        init();

        function init() {
            search();

        }

        function getCompanyDetails(company) {

            if (selectedCompany) {
                const companyDetails = company.find(company => company.name === selectedCompany.companyName);
                vm.companySelected = companyDetails;
                initOffices(vm.companySelected.id);
            }


        }

        function search(val) {
            ClientService.Company.getAll(
                res => {
                    const company = res.content;
                    const notInclude = notEncludesIds();
                    getCompanyDetails(company);
                    vm.companyList = company.filter(item => !notInclude.includes(item.id));

                },
                err => {
                    console.log(err)
                }, { size: 500, active: true, name: val }
            )
        }

        function initOffices(companyId) {
            vm.officesTable.updateData(companyId, selectedCompany);
            vm.officesTableData = vm.officesTable.tableData;

        }

        function selectAll() {
            let newData = {
                selectedCompany: angular.copy(vm.companySelected),
                offices: []
            };
            $uibModalInstance.close(newData);
        }

        function notEncludesIds() {
            const company = [];
            if (!companies) return
            companies.forEach(item => {
                company.push(item.id);
            });

            return company || [];
        }
        function modalDismiss() {
            $uibModalInstance.close()
        }

        function confirm() {
            let newData = {
                selectedCompany: angular.copy(vm.companySelected),
                offices: vm.officesTable.selectedOffices()
            };
            $uibModalInstance.close(newData);

        }

        function close() {
            $uibModalInstance.close();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/administration/modal/companyAccessModalController.js